export default "__VITE_ASSET__KkhTzPdW__"